// extracted by mini-css-extract-plugin
export default {"App":"App_App__9oZjm","Content":"App_Content__WYlvD"};